import { makeObservable, observable } from 'mobx';
import { useStores } from '../useStores';

import {
    searchPublishers,
    loginAsSuperAdmin,
    updateStatus,
    updateFeatured,
    updateBasicDetails,
    updatePublisherInfo,
    updateEmail,
    updateActivePublisher,
    updateExpiryDate,

    paginate,
    resetPagingation,
    reloadSearch,

    getPublisherById,
} from './actions';

import {
    createPublisherUser,
    getPublisherUsers,
    deletePublisherUsers,
    activatePublisherUsers,
    updatePublisherUsers,
} from './actions_publisher_users';

import {
    updatePlan,
    getPlans,
    getPublisherCurrentPlan,
} from './actions_plans';

import {
    setActivePublisher,
    saveActivePublisher,
    loadActivePublisher,
    saveSearchFilters,
    loadSearchFilters,
} from './actions_persists';

import {
    getPublisherDetails,
    updatePublisherDetails,
    uploadCoverPhoto,
} from './action_publisher_details';

export default class PublishersStore {
    env = null
    observed = {
        publisherDetails: null,
        assets: {},
        featuredOverrides: {},
    };
    assets = {};
    // Locally tracked featured toggles, keyed by publisherId — kept separate from
    // `publishers` (the raw list-query results) so toggling one doesn't require
    // re-rendering the whole table, only the switch whose override changed.
    featuredOverrides = {};
    publishers = [];
    publisherUsers = [];
    pageInfo = {
        showPagingation: false,
        page: 0,
        itemsPerPage: 10,
        totalCount: 0,
    };

    pubUsersPageInfo = {
        showPagingation: false,
        page: 0,
        itemsPerPage: 10,
        totalCount: 0,
    };

    publisherDetails = null;
    superAdminDashboard = false;
    constructor () {
        makeObservable(this, {
            observed: observable,
        });
    }

    searchPublishers = searchPublishers;
    loginAsSuperAdmin = loginAsSuperAdmin;
    updateStatus = updateStatus;
    updateFeatured = updateFeatured;
    saveActivePublisher = saveActivePublisher;
    loadActivePublisher = loadActivePublisher;
    setActivePublisher = setActivePublisher;
    updateBasicDetails = updateBasicDetails;
    updatePublisherInfo = updatePublisherInfo;
    updateEmail = updateEmail;
    saveSearchFilters = saveSearchFilters;
    loadSearchFilters = loadSearchFilters;

    updateActivePublisher = updateActivePublisher;
    updateExpiryDate = updateExpiryDate;

    updatePlan = updatePlan;
    getPlans = getPlans;
    getPublisherCurrentPlan = getPublisherCurrentPlan;

    createPublisherUser = createPublisherUser;
    getPublisherUsers = getPublisherUsers;
    activatePublisherUsers = activatePublisherUsers;
    updatePublisherUsers = updatePublisherUsers;
    deletePublisherUsers = deletePublisherUsers;

    paginate = paginate;
    resetPagingation = resetPagingation;
    reloadSearch = reloadSearch;
    getPublisherById = getPublisherById;

    /* Publisher Details */
    getPublisherDetails = getPublisherDetails;
    updatePublisherDetails = updatePublisherDetails;
    uploadCoverPhoto = uploadCoverPhoto;
}

export function usePublishersStore () {
    const { publishersStore } = useStores();
    return publishersStore;
}
